export enum NotificationActionEnum {
  CREATE_USER = 'CREATE_USER',
  UPDATE_USER = 'UPDATE_USER',
  DELETE_USER = 'DELETE_USER',
}

export enum NotificationTypeEnum {
  notification = 'notification',
  file_export = 'file_export',
  error = 'error'
}
